import React from 'react';
import { Box, Typography, Paper, Divider, Button } from '@mui/material';

function FinalResults({ student, results }) {
    
    // Function to handle the redirect
    const handleClose = () => {
        // Redirects the user's browser window to the specified URL
        window.location.href = 'https://ready4industry.in';
    };

    const assessmentData = [
        { id: 'technical', title: 'Technical Assessment', result: results.technical, color: 'primary' },
        { id: 'aptitude', title: 'Aptitude & Reasoning', result: results.aptitude, color: 'secondary' },
        { id: 'behavioural', title: 'Behavioural & Communication', result: results.behavioural, color: 'info' },
    ];
    
    // Calculate overall percentage for display
    const totalScore = assessmentData.reduce((sum, item) => sum + (item.result?.totalScore || 0), 0);
    const overallTotal = assessmentData.reduce((sum, item) => sum + (item.result?.totalQuestions || 0), 0);
    const overallPercentage = overallTotal > 0 ? Math.round((totalScore / overallTotal) * 100) : 0;
    
    return (
        <Paper elevation={6} sx={{ 
            p: { xs: 2, md: 4 }, 
            my: 2, 
            borderRadius: 2,
            // CRITICAL FIX: Set max height relative to viewport and allow internal scroll
            maxHeight: 'calc(100vh - 180px)', 
            overflowY: 'auto', 
        }}>
            <Typography variant="h4" gutterBottom align="center" color="primary" sx={{ fontWeight: 700 }}>
                Assessment Summary
            </Typography>
            <Typography variant="h6" gutterBottom align="center" sx={{ mb: 2 }}>
                Candidate: {student.name}
            </Typography>
            
            {/* Overall Score Card - Compacted */}
            <Paper variant="outlined" sx={{ p: 2, mb: 3, bgcolor: 'primary.light', textAlign: 'center' }}>
                 <Typography variant="h5" sx={{ fontWeight: 700, color: 'primary.dark' }}>
                    Final Score: {totalScore} / {overallTotal}
                </Typography>
                <Typography variant="h3" sx={{ fontWeight: 900, color: 'secondary.main', mt: 0.5 }}>
                    {overallPercentage}%
                </Typography>
            </Paper>

            {/* Individual Section Summary - Compacted */}
            <Typography variant="h6" gutterBottom sx={{ mt: 3, mb: 2, fontWeight: 600 }}>
                Section Summary:
            </Typography>
            
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                {assessmentData.map((assessment) => (
                    <Paper key={assessment.id} elevation={1} sx={{ p: 1.5, borderLeft: `4px solid ${assessment.color}.main` }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 700, color: assessment.color + '.dark', mb: 0.5 }}>
                            {assessment.title}
                        </Typography>
                        
                        {assessment.result ? (
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                {/* 1. Marks Obtained */}
                                <Box display="flex" justifyContent="space-between">
                                    <Typography variant="body2">Score:</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                        {assessment.result.totalScore} / {assessment.result.totalQuestions}
                                    </Typography>
                                </Box>
                                {/* 2. Questions Attempted */}
                                <Box display="flex" justifyContent="space-between">
                                    <Typography variant="body2">Attempted:</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'success.main' }}>
                                        {assessment.result.attemptedCount}
                                    </Typography>
                                </Box>
                                {/* 3. Questions Unattempted */}
                                <Box display="flex" justifyContent="space-between">
                                    <Typography variant="body2">Unattempted:</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'error.main' }}>
                                        {assessment.result.unattemptedCount}
                                    </Typography>
                                </Box>
                            </Box>
                        ) : (
                            <Typography variant="body2" color="error">
                                Test Incomplete.
                            </Typography>
                        )}
                    </Paper>
                ))}
            </Box>
            
            <Divider sx={{ my: 3 }} />
            
            {/* Close Button with redirect */}
            <Box sx={{ textAlign: 'center' }}>
                <Button
                    variant="contained"
                    color="primary"
                    size="medium" 
                    onClick={handleClose}
                    sx={{ py: 1, px: 4, fontSize: '1rem', fontWeight: 700 }}
                >
                    Close & Return to Ready4Industry
                </Button>
            </Box>
        </Paper>
    );
}

export default FinalResults;